import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ActionIconButton,
  TableBodySkeleton,
} from '../../../../common/components';
import { getLotLabel } from '../utils/lotTicketsUtils';

const LotTicketsDataTable = ({
  data,
  isLoading,
  onEdit,
  onDelete,
  LoadingComponent,
  lots,
  allotments,
  canEditLots = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const lotMap = new Map((lots || []).map((lot) => [lot.uuid, lot]));
  const allotmentMap = new Map((allotments || []).map((allotment) => [allotment.uuid, allotment]));
  const getLotName = (uuid) => {
    const lot = lotMap.get(uuid);
    const allotment = lot ? allotmentMap.get(lot.uuid_allotment) : null;
    return getLotLabel(lot, allotment?.name || '');
  };

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <TableBodySkeleton variant="box" />
        ) : data && data.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {data.map((ticket, index) => (
              <Box
                key={ticket.uuid || index}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 2,
                  mb: 2,
                  backgroundColor: 'white',
                }}
              >
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 1, mb: 2 }}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Lote
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {getLotName(ticket.uuid_lot)}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Boleto
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {ticket.ticket_number || '-'}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Nombre
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {ticket.full_name}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      DNI
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {ticket.dni}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Contacto
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {ticket.email || ticket.phone_number || 'Sin contacto'}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton
                    variant="edit"
                    onClick={() => onEdit(ticket)}
                    disabled={!canEditLots}
                  />
                  <ActionIconButton
                    variant="delete"
                    onClick={() => onDelete(ticket)}
                    disabled={!canEditLots}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron boletos" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="lot tickets table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="20%" wxs="25%">
              Lote
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Boleto
            </HeadTableCell>
            <HeadTableCell wmd="30%" wxs="35%">
              Nombre
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              DNI
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Email
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="10%">
              Acciones
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((ticket, index) => (
              <TableRow key={ticket.uuid || index}>
                <RowTableCell>{getLotName(ticket.uuid_lot)}</RowTableCell>
                <RowTableCell>{ticket.ticket_number || '-'}</RowTableCell>
                <RowTableCell>{ticket.full_name}</RowTableCell>
                <RowTableCell>{ticket.dni}</RowTableCell>
                <RowTableCell>{ticket.email || 'Sin email'}</RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <ActionIconButton
                    variant="edit"
                    onClick={() => onEdit(ticket)}
                    disabled={!canEditLots}
                  />
                  <ActionIconButton
                    variant="delete"
                    onClick={() => onDelete(ticket)}
                    disabled={!canEditLots}
                  />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={6} message="No se encontraron boletos" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default LotTicketsDataTable;
